import axios from 'axios';

const { REACT_APP_EXT_API_HOST, REACT_APP_API_HOST } = process.env;

const API_HOST = REACT_APP_API_HOST ? REACT_APP_API_HOST : '';
const API_EXT_HOST = REACT_APP_EXT_API_HOST;

const config = {
  timeout: 3000,
  headers: {
    'Content-Type': 'application/json',
  },
};

const api = {
  ownapi: axios.create({
    baseURL: API_HOST,
    ...config,
  }),

  extapi: axios.create({
    baseURL: API_EXT_HOST,
    ...config,
  }),
};

export default api;
